<template>
  <div>  
    <b-modal id="modal_hotelTurnos" size="lg" :title="titulo"
        hide-header ok-only content-class="shadow"
        button-size="sm" centered ok-title="Cancelar" ok-variant="outline-secondary">

        <hotelTurnos/> 

    </b-modal>
  </div>
</template>

<script>
import hotelTurnos from '@/components/hotel-turnos.vue'
export default {
  components: {
    hotelTurnos,
  },
  data() {
    return {      
        titulo: "Establecimientos - Turnos/Precios"
    }
  },
  computed: {
  },
  methods: {
      close() { //alert('cerrar');
          this.hideModal();    
      },
  }
}
</script>
